import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";

const DEFAULT_LOCALE = "sk";
const SUPPORTED_LOCALES = [
  DEFAULT_LOCALE,
  ..."cs,en,de".split(",").map((l) => l.trim()).filter(Boolean),
];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    // Primary fallback is the project default locale; secondary is English
    // so any key missing from a non-English file still resolves to readable
    // copy instead of the raw key.
    fallbackLng: [DEFAULT_LOCALE, "en"],
    supportedLngs: SUPPORTED_LOCALES,
    // Treat "" as missing so i18next walks the fallback chain.
    returnEmptyString: false,
    interpolation: {
      escapeValue: false, // React already escapes
    },
    backend: {
      loadPath: "/locales/{{lng}}/translation.json",
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },
  });

export { SUPPORTED_LOCALES, DEFAULT_LOCALE };
export default i18n;
